// extracted by mini-css-extract-plugin
module.exports = {"blueBox":"blue-box-module--blueBox--1DSv5","controls":"blue-box-module--controls--uGSj4"};